import React from 'react';
import { InfoIcon } from 'lucide-react';
export function AudienceSection() {
  return <section className="bg-white py-16 lg:py-24" data-id="element-2" data-mp="n0yrt6mo4svx">
      <div className="mx-auto grid max-w-5xl gap-10 px-5 lg:grid-cols-[1.2fr_1fr] lg:items-center" data-id="element-3" data-mp="mzoqm8kir4l2">
        <div data-id="element-4" data-mp="s1e1no7qri95">
          <h2 className="font-display text-3xl font-extrabold leading-tight text-navy sm:text-4xl" data-id="element-5" data-mp="ryrwfv8bpeu3">
            Made for Homeowners Who Want a Clearer Starting Point
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-ink" data-id="element-6" data-mp="3vj4opu7406nx">
            This pack is for you if you’re new to pool care, want to organize your routine, or need a
            practical reference for common questions.
          </p>
        </div>
        <aside className="rounded-2xl border-l-4 border-aqua bg-mist p-6" data-id="element-7" data-mp="e1bougeajf0r">
          <p className="flex items-center gap-2 font-display font-bold text-navy" data-id="element-8" data-mp="e2muymv7kyv1">
            <InfoIcon className="h-5 w-5 text-aqua" aria-hidden="true" data-id="element-9" data-mp="3copok192a7yi" />
            Will it work for my pool?
          </p>
          <p className="mt-3 leading-relaxed text-ink" data-id="element-10" data-mp="14asw8mgnyu4o">
            Designed for residential pools with chlorine-based sanitation, including saltwater
            chlorine generators. Equipment and treatment instructions depend on your specific setup.
          </p>
        </aside>
      </div>
    </section>;
}